import { Plus, Zap, Bug, MinusCircle } from 'lucide-react';
import { VERSION_TYPES, VersionTipo } from '../../config/versionTypes';

interface VersionTypeBadgeProps {
  readonly tipo: VersionTipo;
}

const iconMap = {
  Plus,
  Zap,
  Bug,
  MinusCircle,
};

export function VersionTypeBadge({ tipo }: VersionTypeBadgeProps) {
  const typeConfig = VERSION_TYPES[tipo];
  const IconComponent = iconMap[typeConfig.icon as keyof typeof iconMap];

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded border ${typeConfig.color}`}>
      <IconComponent className="w-3 h-3" />
      {typeConfig.label}
    </span>
  );
}
